import { CLASSIFICATION_META, tagColor } from "@/lib/format";

export const ClassificationBadge = ({ classification }) => {
  const meta = CLASSIFICATION_META[(classification || "").toLowerCase()] || {
    label: classification || "unclassified",
  };
  const color = tagColor(classification);
  return (
    <span
      data-testid="classification-badge"
      className="inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.12em]"
      style={{ color, borderColor: color }}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      {meta.label}
    </span>
  );
};

export const Confidence = ({ level }) => {
  const v = (level || "").toLowerCase();
  const dots = v === "high" ? 3 : v === "moderate" ? 2 : 1;
  return (
    <span className="inline-flex items-center gap-1.5" title={`${level || "low"} confidence`}>
      <span className="overline">{level || "low"}</span>
      <span className="flex items-center gap-0.5">
        {[1, 2, 3].map((i) => (
          <span
            key={i}
            className="h-1.5 w-1.5 rounded-full"
            style={{ background: i <= dots ? "hsl(var(--foreground))" : "hsl(var(--border))" }}
          />
        ))}
      </span>
    </span>
  );
};

export default ClassificationBadge;
